<template src="./password.html"></template>

<script>
import axios from 'axios'
  export default {
    name: 'password',
    data: function () {
      return {
        token: null,
        password: null,
        confirmPassword: null
      }
    },
    methods: {
      reset: function () {
        if (!this.password || !this.confirmPassword) {
          this.errorNotification('Please fill in both password fields')
          return
        }
        if (this.password !== this.confirmPassword) {
          this.errorNotification('Passwords do not match')
          return
        }
        if (this.password.length < 6) {
          this.errorNotification('Password must be at least 6 characters long')
          return
        }
        axios.post('/api/auth/reset-password', {
          token: this.token,
          new_password: this.password
        }).then(response => {
          this.successNotification((response.data && response.data.message) || 'Password has been reset')
          this.$router.push('/login')
        }).catch(err => {
          const msg = (err.response && err.response.data && err.response.data.error) || err.message || 'Reset failed'
          this.errorNotification(msg)
          if (err.response && err.response.status === 400) {
            this.$router.push('/login')
          }
        })
      }
    },
    created: function () {
      this.token = this.$route.params.token
      if (!this.token) {
        this.errorNotification('Invalid reset link')
        this.$router.push('/login')
      }
    }
  }
</script>

<style scoped>

</style>
